/* eslint-disable @typescript-eslint/member-ordering */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Question, SurveyModel } from '@empathy/survey/base';

import { SurveyViewerService } from '../../services/survey-viewer.service';

@Component({
  selector: 'empathy-end-page-view',
  templateUrl: 'end-page-view.component.html',
  styleUrls: ['./end-page-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EndPageViewComponent {
  @Input() surveyModel: SurveyModel;
  @Input() set terminatedBy(qId: string) {
    this.terminateQuestion = this.surveyViewerService.questions[qId];
  }
  @Output() completed = new EventEmitter<void>();

  terminateQuestion: Question;

  constructor(private surveyViewerService: SurveyViewerService) {}
}
